export class SaveSendMessage {
    artistId!: string
    galleryId!: string
    textMessage!: string
}

 

export class Messages {
    Id!: string;
    ArtistId!: string;
    GalleryId!: string;
    TextMessage!: string;
    SentDate!: Date;
    SenderImgUrl!: string | undefined;
    SenderName!: string | undefined;
    IsSenderAnArtist!: boolean;
    IsEventMessage!: boolean
    RefrenceId!: string
    EventTypeId!: string
    EventHeading!: string
    SoldProductDetailOnChatBox!: SoldProductDetailOnChatBox | null;
}

export class SoldProductDetailOnChatBox {
    Id!: string;
    SerialNumber!: string;
    Name!: string;
    ProductImgUrl!: string;
    IsSold!: boolean;
    SoldPrice!: null;
    SoldDate!: null;
    RetailPrice!: number;
    SoldOnPlateform!: null;
    TargetPlateFormSoldPrice!: number;
    TargertPlateFormSoldProductCurrencySymbol!: null;
    ExchangeRateOnSoldProduct!: number;
    GalleryFirstName!: string;
    GalleryLastName!: string;
    GalleryBusinessName!: string
}

export class ChatUser {
    Id!: string
    ImgUrl!: string;
    IsSenderAnArtist!: boolean;
    LastMessage!: string;
    Name!: string;
    UserName!: string;
    BusinessName?: string;
    Time!: Date;
    UnreadMessageCount!: number;
    isSelected?: boolean

}